import { render, staticRenderFns } from "./SuggestionArchive.vue?vue&type=template&id=54d2edf4"
import script from "./SuggestionArchive.vue?vue&type=script&lang=js"
export * from "./SuggestionArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports